import React from 'react';
import Pagination from './_Pagination';
import { allowedTablePartProps } from '../utils/allowedPropTypes';

const DataTableFoot = ({ paginationData: paginationProps = {} }) => {
  const { renderLocation } = paginationProps;

  return (
    <tfoot>
      {renderLocation === 'bottom' || renderLocation === 'both' ? <Pagination {...paginationProps} /> : null}
    </tfoot>
  );
};

DataTableFoot.propTypes = allowedTablePartProps;

export default DataTableFoot;